import { render, staticRenderFns } from "./WideContactsData.vue?vue&type=template&id=b1fad3dc&scoped=true&"
import script from "./WideContactsData.vue?vue&type=script&lang=js&"
export * from "./WideContactsData.vue?vue&type=script&lang=js&"
import style0 from "./WideContactsData.vue?vue&type=style&index=0&id=b1fad3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fad3dc",
  null
  
)

export default component.exports